<script lang="ts">
	import { AdaptiveVideo } from '@wiseed/wikit';
	import type { AdaptiveVideoSrc } from '@wiseed/wikit';
	import { enableVendor, getVendorId, getVendorName } from '@app/utils/didomi';
	import { t } from 'svelte-i18n';
	import { consentVendorsStore } from '@app/stores/consent';

	export let src: AdaptiveVideoSrc;
	export let classNames: string = '';
	export let loop = false;
	export let autoplay = false;
	export let controls = false;
	export let muted = false;
	export let iframe = false;
	export let ratio = '';
	export let iframeTitle;

	let vendorId: string, vendorName: string, isConsent: boolean;

	$: if (iframe && src) {
		vendorId = getVendorId(src as string);
	}

	$: if ($consentVendorsStore !== {} && $consentVendorsStore[vendorId]) {
		isConsent = vendorId && $consentVendorsStore[vendorId].consent;
		vendorName = getVendorName(vendorId);
	}
</script>

<AdaptiveVideo
	{src}
	{classNames}
	{loop}
	{autoplay}
	{controls}
	{muted}
	{iframe}
	{ratio}
	{iframeTitle}
	{isConsent}
	consentMessage={$t('consent.videoProviderMessage', { values: { name: vendorName } })}
	consentCTALabel={$t('consent.watchVideoBtnLabel')}
	consentCTACallbackFunction={() => {
		enableVendor(vendorId);
	}}
/>
